import { client } from "../client";
import { Paginated, PaginatedFilter } from "../types/axios.types";
import { Supply } from "../types/supplies.types";

export const fetchSupplies = async (page?: number, size?: number, search?: string, filters?: PaginatedFilter, sortBy?: string[]) => {
    const params = new URLSearchParams();
    // Pagination
    params.append('page', page ? page.toString() : '1')
    params.append('size', size ? size.toString() : '25')
    // Search
    if (search) {
        params.append('search', search)
    }
    // Sort
    if (sortBy) {
        sortBy.forEach(key => params.append('sort', key))
    }
    // Filters
    if (filters) {
        Object.keys(filters).forEach((key: string) => {
            // Blacklist some keys
            if (["page", "size", "search", "sort"].includes(key) || filters[key] === '') {
                return
            }
            params.append(key, Array.isArray(filters[key]) ? filters[key].join(',') : filters[key]);
        })
    }
    // Query
    const response = await client.get<Paginated<Supply[]>>(`supplies/`, {
        params
    });
    return response.data
};